import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Tracking, TrackingEvent} from '@common/tracking'
import {Icon} from '@components/common/base/icon'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {ExtensionStore} from '@components/extensions-gallery/extensions-store'
import {cn} from '@containers/html-utils'

const TwCommentsLink = tw.a`
  flex
  gap-4
  cursor-pointer

  group
  hover:text-action-default
`

export const ExtensionCommentsLink = ({
  extensionStore,
  onOpenDetails,
  tooltipContent
}: {
  extensionStore: ExtensionStore
  onOpenDetails: () => void
  tooltipContent: string | undefined
}) => {
  const component = (
    <TwCommentsLink
      className={cn(tooltipContent ? 'text-action-default' : 'text-secondary')}
      onClick={() => {
        onOpenDetails()
        Tracking.send(TrackingEvent.extensionsClickOnExtensionCommentsLink)
      }}
    >
      <Icon
        icon="IconMessage"
        color={tooltipContent ? 'action-default' : 'grey'}
        className="group-hover:text-action-default"
      />
      {extensionStore.commentsCount === 0
        ? Lang.msg.extensions.gallery.leaveComment
        : Lang.msg.commentsCount(extensionStore.commentsCount)}
    </TwCommentsLink>
  )

  if (tooltipContent) {
    return (
      <Tooltip
        content={tooltipContent}
        visible
        trigger="manual"
        offset={[2, 6]}
      >
        {component}
      </Tooltip>
    )
  }

  return component
}
